export * from "@vaadin/accordion/vaadin-accordion-heading.js";
export * from './generated/AccordionHeading.js';
